var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstall3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 29.5,
    width: 151,
    height: 88,
    rx: 2.5,
    fill: "white",
    stroke: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 31.5,
    width: 147,
    height: 84,
    rx: 1.5,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 117.5H95.2727L88 130.5H91.3939L104 117.5Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206 117.5H214.727L222 130.5H218.606L206 117.5Z",
    stroke: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129 65.8519V58C129 55.7909 130.791 54 133 54H177C179.209 54 181 55.7909 181 58V90C181 92.2091 179.209 94 177 94H133C130.791 94 129 92.2091 129 90V82.1481",
    stroke: "#13AE67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129 74.002H155",
    stroke: "#13AE67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.778 66.2218L154.142 72.5858C154.923 73.3668 154.923 74.6332 154.142 75.4142L147.778 81.7782",
    stroke: "#13AE67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstall3);
export default __webpack_public_path__ + "static/media/ic-install-3.3d1e1c14b24373337c418101d3e6401e.svg";
export { ForwardRef as ReactComponent };